import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  constructor(private http: CustomHttpService) {}

  // ============ Notification Configuration APIs ============
  
  getAuthorizedDomains(body: any): Observable<any> {
    return this.http.post(environment.getAuthorizedDomains, body);
  }

  getNotificationEmails(body: any): Observable<any> {
    return this.http.post(environment.getNotificationEmails, body);
  }

  addNotificationEmail(body: any): Observable<any> {
    return this.http.post(environment.addNotificationEmail, body);
  }

  deleteNotificationEmail(body: any): Observable<any> {
    return this.http.post(environment.deleteNotificationEmail, body);
  }

  getModuleEmailAssignments(body: any): Observable<any> {
    return this.http.post(environment.getModuleEmailAssignments, body);
  }

  saveModuleEmailAssignments(body: any): Observable<any> {
    return this.http.post(environment.saveModuleEmailAssignments, body);
  }

  // ============ Communication Configuration APIs ============
  
  getCommunicationConfig(body: any): Observable<any> {
    return this.http.post(environment.getCommunicationConfig, body);
  }

  getOutlookAuthUrl(body: any): Observable<any> {
    return this.http.post(environment.getOutlookAuthUrl, body);
  }

  getGmailAuthUrl(body: any): Observable<any> {
    return this.http.post(environment.getGmailAuthUrl, body);
  }

  checkOutlookConnection(body: any): Observable<any> {
    return this.http.post(environment.checkOutlookConnection, body);
  }

  checkGmailConnection(body: any): Observable<any> {
    return this.http.post(environment.checkGmailConnection, body);
  }

  revokeAccess(body: any): Observable<any> {
    return this.http.post(environment.revokeAccess, body);
  }

  disconnectOutlook(body: any): Observable<any> {
    return this.http.post(environment.disconnectOutlook, body);
  }

  disconnectGmail(body: any): Observable<any> {
    return this.http.post(environment.disconnectGmail, body);
  }

  saveOutlookToken(body: any): Observable<any> {
    return this.http.post(environment.saveOutlookToken, body);
  }

  saveGmailToken(body: any): Observable<any> {
    return this.http.post(environment.saveGmailToken, body);
  }

  // ============ WhatsApp Configuration APIs ============
  
  getWhatsAppConfig(body: any): Observable<any> {
    return this.http.post(environment.getWhatsAppConfig, body);
  }

  saveWhatsAppConfig(body: any): Observable<any> {
    return this.http.post(environment.saveWhatsAppConfig, body);
  }

  testWhatsAppConnection(body: any): Observable<any> {
    return this.http.post(environment.testWhatsAppConnection, body);
  }


  getAllClientDomain(body: any): Observable<any> {
    return this.http.post(environment.getAllClientDomain, body);
  }

  getOrganizationConfig(body: any): Observable<any> {
    return this.http.post(environment.getOrgConfigById, body);
  }

  updateOrganizationConfig(body: any): Observable<any> {
    return this.http.post(environment.updateOrgConfig, body);
  }

  createOrganizationConfig(body: any): Observable<any> {
    return this.http.post(environment.createOrgConfig, body);
  }
}
